package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.game.ActorState
import xim.poc.game.ActorStateComponent
import xim.poc.game.ComponentUpdateResult
import xim.poc.game.JobLevel
import xim.poc.game.actor.components.Inventory
import xim.poc.game.configuration.BehaviorId
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.v0.TacticsUnit
import xim.poc.game.configuration.v0.tactics.behaviors.TacticsBehaviorController
import xim.resource.BlurConfig

class TacticsUnitBehavior(
    val id: BehaviorId,
    val provider: (ActorState) -> TacticsBehaviorController
)

class TacticsUnitConfig(
    val bossUnit: Boolean,
    val hpMultiplier: Float = 1f,
    val allStatMultiplier: Float = 1f,
    val xpMultiplier: Float = 0f,
    val skillOverride: List<SkillId> = emptyList(),
    val scale: Float? = null,
    val blurConfig: BlurConfig? = null,
    val behavior: TacticsUnitBehavior? = null,
    val inventory: Inventory? = null,
    val internalQuality: Int = 0,
)

class TacticsUnitComponent(
    val unit: TacticsUnit,
    val bossUnitConfig: TacticsUnitConfig? = null,
    var mostRecentTurnIndex: Int,
): ActorStateComponent {
    override fun update(actorState: ActorState, elapsedFrames: Float): ComponentUpdateResult {
        return ComponentUpdateResult(emptyList())
    }
}

fun ActorState.isTacticsUnit(): Boolean {
    return this.getComponentAs(TacticsUnitComponent::class) != null
}

fun ActorState.getUnit(): TacticsUnit {
    return this.getRequiredComponentAs(TacticsUnitComponent::class).unit
}

fun ActorState.getUnitLevel(): JobLevel {
    return this.getRequiredComponentAs(TacticsUnitComponent::class).unit.unitLevel
}

fun ActorState.getJobLevel(tacticsJobId: TacticsJobId): Int? {
    return getUnit().jobLevels[tacticsJobId]?.level
}

fun ActorState.getJobConfig(): TacticsJobConfig {
    return this.getUnit().getCurrentJobConfig()
}

fun ActorState.getMostRecentTurn(): Int {
    return this.getRequiredComponentAs(TacticsUnitComponent::class).mostRecentTurnIndex
}

fun ActorState.setMostRecentTurn(turn: Int) {
    this.getRequiredComponentAs(TacticsUnitComponent::class).mostRecentTurnIndex = turn
}

fun ActorState.getUnitConfig(): TacticsUnitConfig? {
    return this.getRequiredComponentAs(TacticsUnitComponent::class).bossUnitConfig
}

fun ActorState.isBossUnit(): Boolean {
    return this.getUnitConfig()?.bossUnit == true
}

class TacticsComponent(
    var position: CursorPosition,
): ActorStateComponent {

    var movementCommand: MovementCommand? = null

    override fun update(actorState: ActorState, elapsedFrames: Float): ComponentUpdateResult {
        return ComponentUpdateResult(emptyList())
    }
}

private fun ActorState.get(): TacticsComponent {
    return this.getRequiredComponentAs(TacticsComponent::class)
}

fun ActorState.getCursorPosition(): CursorPosition {
    return get().position
}

fun ActorState.setCursorPosition(position: CursorPosition) {
    get().position = position
}

fun ActorState.getMovementCommand(): MovementCommand? {
    return get().movementCommand
}

fun ActorState.clearMovementCommand() {
    get().movementCommand = null
}

fun ActorState.setMovementCommand(endPosition: Vector3f) {
    get().movementCommand = MovementCommand(Vector3f(this.position), Vector3f(endPosition))
}
